export const defaultDayOptions = {
    default: {
        day: "numeric",
    },
};
